import React, { type FC } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Flex,
  IconFATrashCanRaw,
  LINK_VARIANT_EXTRALIGHT,
  Link,
} from 'mailup-web-components'

import { panelConfigColumnsRemoveCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'
import { getColumnName } from 'Pages/RecipientsList/recoil/services/results'
import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'
import { panelConfigColumnsState } from 'Pages/RecipientsList/recoil/state/configColumns'

interface ColumnItemProps {
  index: number
  canDelete: boolean
}

const ColumnItem: FC<ColumnItemProps> = ({ index, canDelete }) => {
  const { items } = useRecoilValue(panelConfigColumnsState)
  const dynamicFields = useRecoilValue(dynamicFieldsState)

  const removeColumn = useRecoilCallback(panelConfigColumnsRemoveCallback, [])

  const handleRemove = (): void => {
    void removeColumn(index)
  }

  return (
    <Flex gap="16px">
      <Flex flexGrow={1} height="36px" minWidth="0px" alignItems="center">
        {getColumnName(items[index] as string, dynamicFields)}
      </Flex>
      <Flex
        flexBasis="16px"
        alignItem="center"
        justifyContent="center"
        height="36px"
      >
        <Link
          variant={LINK_VARIANT_EXTRALIGHT}
          disabled={!canDelete}
          alignContent
          data-mu-test="remove-column"
          onClick={handleRemove}
        >
          <IconFATrashCanRaw width="14px" />
        </Link>
      </Flex>
    </Flex>
  )
}

export default ColumnItem
